import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Paper } from "@mui/material";
import PriorApprovalSecondSearch from "./PriorApprovalSecondSearch";
import { useContext, useEffect, useState } from "react";
import { ApprovedSearchContext } from "..";
import PriorRequestList from "./PriorRequestList";
import { getItem, storageKey } from "../../../utilis/methods/storage/storage";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PriorApprovalTabs = () => {
  const [value, setValue] = useState(0);
  const {priorApprovalSearchParams,} = useContext(ApprovedSearchContext)
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

useEffect(()=>{
  if(priorApprovalSearchParams.operation == "download"){
    setValue(0);
  }
},[priorApprovalSearchParams])

useEffect(() => {
  const localpatientData = getItem(storageKey.priorDetailsKey);
  if (Boolean(localpatientData)) {
    setValue(1)
    localStorage.removeItem(storageKey.priorDetailsKey);
  }
}, []);
  return (
    <Paper sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Approved" {...a11yProps(0)} />
          <Tab label="Submission" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <div className={value == 0 ? "block" : "hidden"}>
        <PriorApprovalSecondSearch />
      </div>
      <div className={value == 1 ? "block" : "hidden"}>
        <PriorRequestList />
      </div>
    </Paper>
  );
};

export default PriorApprovalTabs;
